import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityDoc } from "../../entity/EntityDoc";

export class DtoDocsGetRes extends EntityDoc {
  public items: EntityDoc[]  = [];
}
